import classes from "./background.module.css";

const Background = (props: { step: number }) => {
  const {
    step = 0
  } = props;

  return (
    <div className={classes.root}>
      <span className={classes.spin} style={{ transform: `rotate(-${step * 30}deg)` }}/>
    </div>
  );
};

export default Background;
